import styleSheet from "./style.module.scss";
import SyIcon from "../../../../shared/components/sy-icon";
import SyInput from "../../../../shared/forms/sy-input-form";
import OrbButton from "../../../../shared/components/orb-button";
import { Controller, useForm } from "react-hook-form";
import {
  inputProps,
  orbitProps,
  registerPopupProps,
} from "./add-orbit-interface";
import {
  orbitConfigDetails,
  orbitDetails,
  statusOption,
} from "./add-orbit-config";
import SyDropdown from "../../../../shared/forms/sy-dropdown";
import OrbInput from "../../../../shared/forms/orb-input";
import { useDispatch, useSelector } from "react-redux";
import {
  getOrbitDetails,
  setSelectOrbit,
} from "../../../../feature/orbit-slice";
import { getAuthDetails } from "../../../../feature/auth-slice";
import { useMutation } from "@tanstack/react-query";
import orbitService from "../../services/orbit-service";

type Props = {};

const AddOrbitPopup = (props: registerPopupProps) => {
  const { onClose } = props;
  const authSlice = useSelector(getAuthDetails);
  const dispatch = useDispatch();

  const defaultValues = {
    orb_name: "",
    orb_status: statusOption[0],
    orb_description: "",
    orb_company_id: authSlice.company_details.cmp_id,
  };

  const { setValue, getValues, control, handleSubmit } = useForm<orbitProps>({
    defaultValues: defaultValues,
  });

  const InputField = (props: inputProps) => {
    const { name, type, placeholder, label } = props;
    return (
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, value } }) => {
          return (
            <OrbInput
              type={type}
              placeholder={placeholder}
              value={value}
              onChange={onChange}
              // errorMessage={errors?.[field.name]?.message ?? ""}
              label={label}
            />
          );
        }}
      />
    );
  };

  const { mutate: save } = useMutation({
    mutationFn: orbitService.addOrbit,
    onSuccess(data, variables, context) {
      dispatch(setSelectOrbit(data.data.orb_id));
      onClickClose(true);
    },
  });

  const onClickClose = (val: any = false) => {
    onClose(val);
  };
  const onSubmit = (formValue: any) => {
    formValue.orb_status = formValue?.orb_status?.id;
    save(formValue);
  };

  return (
    <div className={`rounded-4  p-3 w-100   pop-bg`}>
      <div className="d-flex align-items-center justify-content-between pb-3">
        <h2 className="mohave m-0 title-font">{orbitConfigDetails.heading}</h2>
        <SyIcon
          name="close"
          iconType="symbols"
          iconStyle="outlined"
          iconColor="white"
          className={` pointer`}
          onClick={onClickClose}
        />
      </div>
      <div>
        <form onSubmit={handleSubmit(onSubmit)}>
          {orbitConfigDetails.fieldDetails.map((field: any) => {
            return (
              <div className="">
                <InputField
                  name={field.name}
                  type={field.type}
                  placeholder={field.placeholder}
                  label={field.label}
                />
              </div>
            );
          })}
          <div className="d-flex justify-content-end">
            <OrbButton
              type={"submit"}
              className={" mohave "}
              size={""}
              iconName={"save"}
              label={"save"}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddOrbitPopup;
